import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { VideoProviderService } from '../service/video-provider.service';

@Injectable({
    providedIn: 'root'
})
export class VideoProviderValidators
{
    constructor(private videoProviderService: VideoProviderService) { }

    public validateVideoProviderNameUnique(control: UntypedFormControl, initialName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialName !== control.value)
            {
                this.videoProviderService.existsVideoProviderName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
